import '../assets/sass/web/_saleoffer.scss'
import { addEvent } from './utils/gaService'
require('./controller/citySelectController.js')
require('./controller/header.js')
addEvent('link-RealestateResponsiveUI', 'EOFY_Real-Estate', 'page_load');